import { mapGetters } from "vuex";
import { getNewUserRechargeDetail } from "@/lobby_common/api/basic_gen";
import {
  getAppDateLastTimeStampe,
  getAnyZoneTodayDownTimeStamp,
} from "@/lobby_common/utils/date";
import {
  divideAccuracy,
  goJoinEvent,
  SignEventStatus,
} from "@/lobby_common/utils/utils.js";

export default {
  name: "mode14",
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      SignEventStatus,
      divideAccuracy,
      giftImg: require("@/assets/home/gift.png"),
      goldImg: require("@/assets/home/gold.png"),
      goImg: require("@/assets/home/goBtn.png"),
      userRechargeDetail: {
        sign: {},
        firstRecharge: {},
        repeatRecharge: {},
      },
      surplusTime: undefined,
      surplusTxt: undefined,
      timer: null,
    };
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
    lang() {
      return this.$store.getters.getLang;
    },
    getToken() {
      return this.$store.getters.taken;
    },
    showType() {
      return this.item?.showType || 1;
    },
    isShowModel() {
      return (
        this.userRechargeDetail.sign.activityIsValid === "STATUS_BOOL_TRUE" ||
        this.userRechargeDetail.firstRecharge.activityIsValid ===
          "STATUS_BOOL_TRUE" ||
        this.userRechargeDetail.repeatRecharge.activityIsValid ===
          "STATUS_BOOL_TRUE"
      );
    },
    maxRatio() {
      const num1 = Number(this.userRechargeDetail.firstRecharge.ratio) + 10000;
      const num2 = Number(this.userRechargeDetail.repeatRecharge.ratio) + 10000;
      return (num1 + num2) / 100;
    },
    userData() {
      return this.$store.getters.user || {};
    },
    userAccuracy() {
      return this.userData.accuracy;
    },
    userCoinSymbol() {
      return this.userData.coinSymbol;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  watch: {},
  async created() {
    this.$Bus.$on("updateRechargeDetail", () => {
      if (
        this.userRechargeDetail.sign.canDo === "STATUS_BOOL_FALSE" &&
        this.userRechargeDetail.firstRecharge.canDo === "STATUS_BOOL_FALSE" &&
        this.userRechargeDetail.repeatRecharge.canDo === "STATUS_BOOL_FALSE"
      ) {
        // 三个活动都不能参加之后 不再调用接口
        return false;
      }
      // 后台异步  延迟执行
      setTimeout(() => {
        this.getNewUserRechargeDetail();
      }, 1000);
    });
    this.getNewUserRechargeDetail();

    const lastTimeStampe = getAppDateLastTimeStampe();
    // console.log(lastTimeStampe, "this.itemthis.item");
    const time = getAnyZoneTodayDownTimeStamp(Number(lastTimeStampe));
    if (time && time > 0) {
      this.surplusTime = time % (3600000 * 24);
      this.getTime();
    }
  },
  methods: {
    async getNewUserRechargeDetail() {
      // 新人充值
      if (!this.getToken) {
        return false;
      }
      const { code, data } = await getNewUserRechargeDetail({});
      if (code === 0) {
        this.userRechargeDetail = {
          sign: data?.sign || {},
          firstRecharge: data?.firstRecharge || {},
          repeatRecharge: data?.repeatRecharge || {},
        };
      }
    },
    // 倒计时
    getTime() {
      // 美东 -4时间
      // const _this = this
      if (this.timer === null) {
        this.timer = setInterval(() => {
          this.surplusTime = this.surplusTime - 1000;
          if (!this.surplusTime || this.surplusTime < 0) {
            clearInterval(this.timer);
            this.timer = null;
            return false;
          }
          // 剩余时间
          // const surplusHours = this.surplusTime % (3600000 * 24);
          // this.surplusTxt = getAnyZoneTime(surplusHours, 0).substring(11);
          this.down(Math.floor(this.surplusTime / 1000));
        }, 1000);
      }
    },
    down(time) {
      let h = Math.floor(time / 3600);
      let m = Math.floor((time - h * 3600) / 60);
      let s = time % 60;
      h = h > 9 ? h : "0" + h;
      m = m > 9 ? m : "0" + m;
      s = s > 9 ? s : "0" + s;
      this.surplusTxt = h + ":" + m + ":" + s;
    },
    // 去签到
    goSign() {
      const jump = {
        type: "Jump_TYPE_FUNCTION",
        functionType: "JUMP_FUNCTION_TYPE_SIGN",
      };
      this.$eventPost("click", {
        eid: `101_32_${this.curindex}_2`,
        time: Date.now(),
      });
      this.$eventPost("new_recharge", {
        SubNewcomers: "signin"
      });
      goJoinEvent(jump);
    },
    // 去充值
    goCharge(index = "1") {
      const jump = {
        type: "Jump_TYPE_FUNCTION",
        functionType: "JUMP_FUNCTION_TYPE_RECHARGE",
      };
      this.$eventPost("click", {
        eid: `101_32_${this.curindex}_${index}`,
        time: Date.now(),
      });
      this.$eventPost("new_recharge", {
        SubNewcomers: Number(index) === 3 ? "recharge" : "firstCharge"
      });
      goJoinEvent(jump);
    },
  },
  activated() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.$Bus.$off("updateRechargeDetail");
  },
};
